import { createSelector } from 'reselect';
import { skuOptionsPLPSelector } from 'selectors/testTarget/offers/skuOptionsPLP/skuOptionsPLPSelector';

const experienceSelector = createSelector(skuOptionsPLPSelector, skuOptionsPLP => skuOptionsPLP.experience);

export { experienceSelector };
